import React from 'react';

import { ContainerStyled, SubtextStyled } from './TextWithSubtext.styled';

type Props = {
  text: string;
  subtext: string;
};

export function TextWithSubtext({ text, subtext }: Props): JSX.Element {
  return (
    <ContainerStyled>
      <span>{text}</span>
      <SubtextStyled>{subtext}</SubtextStyled>
    </ContainerStyled>
  );
}
